import { render, staticRenderFns } from "./commonButton.vue?vue&type=template&id=250c5b9c&scoped=true&"
import script from "./commonButton.vue?vue&type=script&lang=js&"
export * from "./commonButton.vue?vue&type=script&lang=js&"
import style0 from "./commonButton.vue?vue&type=style&index=0&id=250c5b9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c5b9c",
  null
  
)

export default component.exports